import React from 'react';
import styled from 'styled-components';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Section = styled.section`
  background-color: #119687;
  color: white;
  padding: 80px 20px;
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
`;

const Subtext = styled.p`
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 30px;
`;

const StyledButton = styled(Button)`
  background-color: #ffffff;
  color: #119687;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f0f0f0;
    color: #0d7f73;
  }
`;

const DonationSection = () => {
  const navigate = useNavigate();
  const church = JSON.parse(localStorage.getItem('church')) || {};

  const handleDonate = () => {
    // Navigate to your donation page or open a modal
    window.location.href=church.donation_link
  };

  return (
    <Section id="donate">
      <Container>
        <Heading>{church.donation_heading || 'Support Our Ministry'}</Heading>
        <Subtext>{church.donation_text || 'Your generosity enables us to continue making a difference in our community and beyond.'}</Subtext>
        <StyledButton onClick={handleDonate}>
          {church.donation_button_text || 'Give Now'}
        </StyledButton>
      </Container>
    </Section>
  );
};

export default DonationSection;
